import { render } from "./RelationSteps.vue?vue&type=template&id=585ee376&scoped=true"
import script from "./RelationSteps.vue?vue&type=script&lang=js"
export * from "./RelationSteps.vue?vue&type=script&lang=js"

import "./RelationSteps.vue?vue&type=style&index=0&id=585ee376&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585ee376"]])

export default __exports__